import { createContext } from 'react';

const UserContentItemModifiersContext = createContext({
  onDialogClose: () => {},
  onDialogOpen: () => {},
});

export default UserContentItemModifiersContext;
